// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentMethodResponse

import { StripePaymentMethodType } from './enums.gen';
import { hydrateBillingPaymentMethodCard, type BillingPaymentMethodCard, type BillingPaymentMethodCardApiResponse } from './billingPaymentMethodCard.gen';
import { hydrateBillingPaymentMethodSepaDebit, type BillingPaymentMethodSepaDebit, type BillingPaymentMethodSepaDebitApiResponse } from './billingPaymentMethodSepaDebit.gen';

export type BillingPaymentMethodApiResponse = {
	id: string;
	type: StripePaymentMethodType;
	brand: string | null;
	card: BillingPaymentMethodCardApiResponse | null;
	sepaDebit: BillingPaymentMethodSepaDebitApiResponse | null;
};

export type BillingPaymentMethod = {
	id: string;
	type: StripePaymentMethodType;
	brand: string | null;
	card: BillingPaymentMethodCard | null;
	sepaDebit: BillingPaymentMethodSepaDebit | null;
};

export function hydrateBillingPaymentMethod(data: BillingPaymentMethodApiResponse): BillingPaymentMethod {
	return {
		...data,
		card: data.card ? hydrateBillingPaymentMethodCard(data.card) : null,
		sepaDebit: data.sepaDebit ? hydrateBillingPaymentMethodSepaDebit(data.sepaDebit) : null,
	};
}